<template>
  <div>
    <BModal
      id="modal-subscription-whitelist"
      ref="modal-subscription-whitelist"
      no-stacking
      centered
      hide-footer
      hide-header
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <BRow class="justify-center my-1 flex flex-column">
        <BCol class="flex flex-col text-center gap-2 justify-content-center mb-2">
          <strong class="text-black text-xl">Berlangganan Whitelist</strong>
          <span class="text-black text-md">
            Yuk, berlanggan Google dan TikTok Whitelist untuk mendapatkan akun Whitelisted pakai Kompay—akses istimewa langsung aktif
          </span>
        </BCol>

        <BCol class="justify-content-center">
          <ValidationObserver #default="{ invalid }">
            <!-- Saldo Kompay -->
            <div class="mb-1 border border-gray-200 rounded-md py-2 ps-4 flex justify-between items-center">
              <div class="flex flex-col">
                <label class="font-semibold text-md block text-black">Saldo Kompay</label>
                <div class="text-2xl font-bold text-black">
                  {{ IDR(saldo) }}
                </div>
              </div>
            </div>
            <small
              v-if="!hasEnoughSaldo"
              class="flex flex-row items-center gap-2 text-danger mt-[6px]"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/danger.svg"
                alt="danger"
                width="16"
                height="16"
              >
              <p class="m-0 text-xs">
                Nominal Saldo Kompay kurang, Silahkan
                <a
                  class="!text-[#08A0F7] !underline"
                  @click.prevent="
                    $router.push({ name: 'dashboard-komship' })
                  "
                >topup saldo kompaymu</a>
              </p>
            </small>

            <!-- Platform Whitelist -->
            <BFormGroup label-for="platform">
              <template #label>
                <div class="flex justify-between mt-2">
                  <div class="text-black flex items-center">
                    <strong class="text-base font-semibold">Platform Whitelist</strong>
                    <strong class="text-primary">*</strong>
                  </div>
                </div>
              </template>
              <ValidationProvider
                v-slot="{ errors }"
                name="Platform"
                rules="required"
              >
                <VSelect
                  v-model="selectedPlatform"
                  :options="platformOptions"
                  label="name"
                  placeholder="Pilih disini"
                >
                  <template #no-options>
                    Tidak ada platform
                  </template>
                  <template #option="{ name, image }">
                    <div class="flex items-center gap-2">
                      <img
                        :src="image"
                        alt="Platform icon"
                        width="20"
                        height="20"
                      >
                      <span class="text-black">{{ name }}</span>
                    </div>
                  </template>
                  <template #selected-option="{ name, image }">
                    <div class="flex items-center gap-2">
                      <img
                        :src="image"
                        alt="Platform icon"
                        width="20"
                        height="20"
                      >
                      <span class="text-black">{{ name }}</span>
                    </div>
                  </template>
                </VSelect>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>

            <!-- Durasi Langganan -->
            <BFormGroup v-show="selectedPlatform">
              <template #label>
                <div class="flex justify-between mt-2">
                  <div class="text-black flex items-center">
                    <strong class="text-base font-semibold">Durasi Langganan</strong>
                    <strong class="text-primary">*</strong>
                  </div>
                </div>
              </template>
              <div class="grid grid-cols-3 gap-2">
                <BButton
                  v-for="subs in subscriptionOptions"
                  :key="subs.id"
                  :variant="selectedDuration && selectedDuration.duration_day === subs.duration_day ? 'primary' : 'outline-secondary'"
                  class="rounded-lg p-2 w-full"
                  @click="selectDuration(subs)"
                >
                  <div class="flex flex-col text-left items-center">
                    <span class="text-sm">Durasi {{ subs.duration_day }} Hari</span>
                    <strong>{{ IDR(subs.price) }}</strong>
                  </div>
                </BButton>
              </div>
            </BFormGroup>

            <!-- Batas Minimal Saldo Ideal -->
            <div
              v-if="showIdealBalance"
              class="bg-[#FFEDED] p-1 rounded-lg mb-2"
            >
              <div class="d-flex">
                <span class="k-info-circle-1 text-danger font-bold align-content-center mr-1 text-xl" />
                <div class="font-medium text-black text-[14px] align-content-center">
                  Batas Minimal Saldo Ideal :
                  <b>
                    {{ IDR(idealBalance) }}
                  </b>
                </div>
              </div>
              <div class="mb-1">
                Saldo ideal diterapkan untuk menghindari saldo minus.
                <a
                  class="text-[#08A0F7] underline"
                  href="https://bantuan.komerce.id/id/article/saldo-ideal-komship-7dn9vp/"
                  target="_blank"
                >Pelajari lebih lanjut</a>
              </div>
              <div class="p-1 bg-[#FFFFFF] rounded-lg">
                <div class="flex">
                  <span class="k-message-question font-bold align-content-center mr-1 text-lg" />
                  <div class="font-medium content-center">
                    Darimana Saldo Ideal berasal?
                  </div>
                </div>
                <span>
                  Potensi Pendapatan Order Dikirim
                  <b>{{ IDR(incomeOrderPotential) }}</b>
                  - Ongkir Retur Ketika Sampai
                  <b>{{ IDR(potencyRetur) }}</b>
                  - Resiko Ongkir Menjadi Retur
                  <b>{{ IDR(riskRetur) }}</b>
                  = Saldo Ideal
                  <b class="text-primary">{{ IDR(idealBalance) }}</b>
                </span>
              </div>
            </div>

            <!-- Total Pembayaran -->
            <div class="mt-2">
              <div class="flex justify-between font-medium text-black">
                <div class="text-lg flex items-center">
                  Total Pembayaran
                </div>
                <div class="text-lg font-bold">
                  {{ IDR(totalPayment) }}
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="mt-2 flex cols cols-12 gap-2">
              <BButton
                variant="outline-primary"
                class="rounded-lg px-4 w-full cols-6"
                @click="closeModal"
              >
                Batal
              </BButton>
              <BButton
                :variant="invalid || isSubmitDisabled ? 'secondary' : 'primary'"
                class="rounded-lg px-4 bg-[#FF5C00] border-[#FF5C00] w-full cols-6"
                :disabled="invalid || isSubmitDisabled || showIdealBalance"
                @click="submitSubscription"
              >
                Berlangganan
              </BButton>
            </div>
          </ValidationObserver>
        </BCol>
      </BRow>
    </BModal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { IDR } from '@/libs/currency'
import VSelect from 'vue-select'
import { mapState } from 'vuex'
import { newAxiosIns } from '@/libs/axios'
import moment from 'moment'

export default {
  name: 'ModalSubscriptionWhitelist',
  components: { ValidationProvider, ValidationObserver, VSelect },
  data() {
    return {
      IDR,
      subscriptionOptions: null,
      selectedDuration: null,
      allPlatformOptions: [
        { name: 'Google', image: 'https://storage.googleapis.com/komerce/komads-meta/google.svg', value: 'google' },
        { name: 'Tiktok', image: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg', value: 'tiktok' },
      ],
      selectedPlatform: null,
      notes: '',
      // Ideal balance analytics
      idealBalance: 0,
      incomeOrderPotential: 0,
      potencyRetur: 0,
      riskRetur: 0,
      loading: false,
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
    ...mapState('saldo', ['saldo']),
    totalPayment() {
      return this.selectedDuration ? this.selectedDuration.price : 0
    },
    hasEnoughSaldo() {
      return this.saldo >= this.totalPayment
    },
    showIdealBalance() {
      return (
        this.selectedDuration
        && this.hasEnoughSaldo
        && this.profile.is_komship === 1
        && this.idealBalance > 0
        && this.saldo - this.totalPayment < this.idealBalance
      )
    },
    isSubmitDisabled() {
      return !this.selectedDuration || !this.selectedPlatform || this.loading || !this.hasEnoughSaldo
    },
    /**
     * Filter platform options to show only platforms with 'accepted' account_request_status
     * and exclude meta platform
     * @returns {Array} Array of platform options that have accepted status
     */
    platformOptions() {
      if (!this.totalSpendPlatform || this.totalSpendPlatform.length === 0) {
        // Fallback to all platforms except meta if no total_spend_platform data is provided
        return this.allPlatformOptions.filter(option => option.name.toLowerCase() !== 'meta')
      }

      // Filter platforms that have 'accepted' status and exclude meta
      const acceptedPlatforms = this.totalSpendPlatform.filter(
        platform => platform.account_request_status === 'accepted'
          && platform.platform_name.toLowerCase() !== 'meta',
      )

      // Map accepted platforms to platform options format
      return this.allPlatformOptions.filter(option => acceptedPlatforms.some(accepted => accepted.platform_name.toLowerCase() === option.name.toLowerCase()))
    },
  },
  watch: {
    selectedPlatform(newVal) {
      if (newVal) {
        this.getSubscriptionFee()
      }
    },
  },
  async mounted() {
    await this.getWhitelistInfo()
    await this.checkIdealBalance()
  },
  methods: {
    /**
     * Select duration for subscription
     * @param {Object} subs - Subscription option object
     */
    selectDuration(subs) {
      this.selectedDuration = subs
    },
    closeModal() {
      this.selectedDuration = null
      this.selectedPlatform = null
      this.notes = ''
      this.$bvModal.hide('modal-subscription-whitelist')
    },
    /**
     * Get whitelist info for the current month from the API
     *
     * @returns {void}
     * @throws {Error}
     */
    async getWhitelistInfo() {
      try {
        const response = await newAxiosIns.get('/komads/api/v1/partners/whitelist_info', {
          params: {
            month: moment().format('MM-YYYY'),
          },
        })
        const { data } = response.data
        this.whitelistInfo = data
        this.totalSpendPlatform = data.total_spend_platform
      } catch (error) {
        console.warn(error)
      }
    },
    /**
     * Fetch ideal balance analytics from API
     *
     * @private
     * @returns {void}
     */
    async checkIdealBalance() {
      if (this.profile.is_komship === 1) {
        try {
          const response = await newAxiosIns.get(`/komship/api/v1/admin/partner-consumables/balance-analitycs/${this.profile.partner_id}`)
          const { data } = response.data
          this.idealBalance = data.ideal_balance
          this.incomeOrderPotential = data.income_order_potential
          this.potencyRetur = data.ongkir_retur_on_finished
          this.riskRetur = data.ongkir_risk_become_retur
        } catch (e) {
          console.error(e)
        }
      }
    },
    async getSubscriptionFee() {
      try {
        const { data } = await newAxiosIns.get('/komads/api/v1/subscription_fees', {
          params: {
            platform_name: this.selectedPlatform.name,
          },
        })

        this.subscriptionOptions = data.data
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data fee' })
      }
    },
    async submitSubscription() {
      if (this.isSubmitDisabled) return
      this.loading = true
      try {
        const response = await newAxiosIns.post('/komads/api/v1/whitelist_subscriptions/store', {
          platform: this.selectedPlatform.value,
          platform_name: this.selectedPlatform.name,
          subscription_fee_id: this.selectedDuration.id,
        })

        this.$store.dispatch('saldo/getBalanceSummary')

        const { data } = response.data
        const transactionId = data.id
        this.$emit('subscribe', transactionId)

        // Refresh current route to reflect changes
        const postMessage = { type: 'GET_SUBSCRIPTION' }
        const iframe = document.querySelector('#whitelisted-komads')
        if (iframe) iframe.contentWindow.postMessage(postMessage, '*')

        this.closeModal()
      } catch (error) {
        const errorKey = error.response.data.meta.errors[0].key

        const ERROR_MESSAGE_MAP = {
          invalid_amount: 'Terjadi kesalahan saat melakukan transaksi saldo Komads Whitelisted. Silahkan coba dengan nominal yang berbeda atau hubungi CS',
          minimal_topup_not_reached: 'Transaksi gagal karena saldo Kompay tidak mencukupi. Harap cek kembali saldo Kompay saat ini.',
          account_not_found: 'Akun tidak ditemukan, silahkan hubungi customer service kami',
          fee_topup_not_found: 'Biaya top up tidak ditemukan, silahkan hubungi customer service kami',
        }

        const userFriendlyMessage = ERROR_MESSAGE_MAP[errorKey]
        || 'Terjadi kesalahan pada sistem. Coba lagi beberapa saat atau hubungi CS.'

        this.$toast_error({ message: userFriendlyMessage })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.border {
  border-color: #e2e2e2 !important;
}
</style>
